module.exports = {
      id: "payment-1-usage",
      viewBox: "0 0 43 45",
      url: __webpack_public_path__ + "img/icons.e66ad95c.svg#payment-1-usage",
      toString: function () {
        return this.url;
      }
    }